<template>
    <div class="mitglieder-select">
        <b-input
            :id="id"
            class="mitglieder-filter"
            type="text"
            :size="size"
            :placeholder="
                mitglieder.busy
                    ? 'Mitglieder werden geladen...'
                    : 'Nach Mitgliedern suchen'
            "
            :disabled="mitglieder.busy"
            @input="filterMitglied"
        />
        <b-select
            class="mitglieder-options"
            :options="mitgliederSelect"
            :select-size="5"
            :size="size"
            :value="localValue"
            :disabled="mitglieder.busy"
            @input="input"
        />
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";

const MitgliederApi = ApiFactory.get("mitglieder");

import "./MitgliederSelect.scss";

export default {
    name: "MitgliederSelect",
    props: ["id", "value", "size", "op"],
    data() {
        return {
            mitglieder: {
                busy: false,
                data: [],
                filterData: []
            },
            localValue: this.value
        };
    },
    computed: {
        mitgliederSelect() {
            // let selectItems = [];
            // if(this.op) {
            //     selectItems = this.mitglieder.filterData.map(item => {
            //         return {
            //             value: {
            //                 id: item.id,
            //                 name: item.name,
            //                 vorname: item.vorname
            //             },
            //             text: item.name + ", " + item.vorname + " (" + item.id + ")"
            //         };
            //     });
            // } else {
                return this.mitglieder.filterData.map(item => {
                    return {
                        value: item.id,
                        text: item.name + ", " + item.vorname + " (" + item.id + ")"
                    };
                });
            // }
            // return selectItems;
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.localValue = newValue;
            }
        }
    },
    created() {
        this.fetch();
    },
    methods: {
        async fetch() {
            this.mitglieder.busy = true;

            let response = {};
            if(this.op) {
                response = await MitgliederApi.getOPRelevants({
                    fields: ["id", "vorname", "name"],
                    order: "name",
                    sort: "asc",
                    limit: -1
                });
            } else {
                response = await MitgliederApi.get({
                    fields: ["id", "vorname", "name"],
                    order: "name",
                    sort: "asc",
                    limit: -1
                });
            }

            if (response.ok) {
                const items = response.json.collection;

                this.mitglieder.data = items;
                this.mitglieder.filterData = items;
            }
            this.mitglieder.busy = false;
        },
        filterMitglied(value) {
            value = String(value).toLowerCase();
            this.mitglieder.filterData = this.mitglieder.data.filter(item => {
                return (
                    String(item.vorname)
                        .toLowerCase()
                        .includes(value) ||
                    String(item.name)
                        .toLowerCase()
                        .includes(value) ||
                    String(item.id)
                        .toLowerCase()
                        .includes(value)
                );
            });
        },
        input(value) {
            this.$emit("input", value);
        }
    }
};
</script>
